module.exports = __webpack_public_path__ + "static/media/default-user-photo.a3e4bc7b.png";